// extracted by mini-css-extract-plugin
export default {"datasetPreviewLink":"DatasetPreviewColumn-module__datasetPreviewLink___hQGlY"};